import * as React from 'react'
import { useTranslation } from 'react-i18next'

import { LOCIZE_NAMESPACE as NAMESPACE } from 'main/common'
import { Networks, useWhitelabel } from 'main/framework'

const PRE = 'ONBOARDING-LICENSING-PROGRAM-TYPE'

export function useProgramTypesForSearchFilter() {
  const { t, i18n } = useTranslation(NAMESPACE)
  const whitelabel = useWhitelabel()

  function generalProgramTypes() {
    return [
      { label: t(`${PRE}-FCC`), value: 'fcc' },
      { label: t(`${PRE}-CENTER`), value: 'center' },
      { label: t(`${PRE}-FOREST`), value: 'forest' },
      { label: t(`${PRE}-MICRO`), value: 'micro' },
      { label: t(`${PRE}-NANNY`), value: 'nanny' },
      { label: t(`${PRE}-MINISTRY`), value: 'ministry' },
      { label: t(`${PRE}-OTHER`), value: 'other' },
    ]
  }

  function whitelabeledProgramTypes(
    key: string | undefined,
  ): Array<{ label: string; value: string }> | undefined {
    const programTypeLookup = {
      [Networks.ELI]: [
        { label: t(`${PRE}-FCC`), value: 'fcc' },
        { label: t(`${PRE}-CENTER`), value: 'center' },
        { label: t(`${PRE}-MINISTRY`), value: 'ministry' },
        { label: t(`${PRE}-EXEMPT`), value: 'exempt' },
      ],
      [Networks.NM]: [
        { label: t(`${PRE}-FCC-NM`), value: 'fcc' },
        { label: t(`${PRE}-CENTER-NM`), value: 'center' },
      ],
    }
    // @ts-ignore
    return programTypeLookup[key]
  }

  return React.useMemo(
    () => whitelabeledProgramTypes(whitelabel.networkAbbr) || generalProgramTypes(),
    [i18n.language],
  )
}

export function useProgramTypes() {
  const { t, i18n } = useTranslation(NAMESPACE)
  const whitelabel = useWhitelabel()

  function generalProgramTypes() {
    return [
      { label: t(`${PRE}-FCC`), value: 'fcc' },
      { label: t(`${PRE}-CENTER`), value: 'center' },
      { label: t(`${PRE}-FOREST`), value: 'forest' },
      { label: t(`${PRE}-MICRO`), value: 'micro' },
      { label: t(`${PRE}-NANNY`), value: 'nanny' },
      { label: t(`${PRE}-OTHER`), value: 'other' },
    ]
  }

  function whitelabeledProgramTypes(
    key: string | undefined,
  ): Array<{ label: string; value: string }> | undefined {
    const programTypeLookup = {
      [Networks.ELI]: [
        { label: t(`${PRE}-FCC`), value: 'fcc' },
        { label: t(`${PRE}-CENTER`), value: 'center' },
        { label: t(`${PRE}-MINISTRY`), value: 'ministry' },
        { label: t(`${PRE}-EXEMPT`), value: 'exempt' },
      ],
      [Networks.NM]: [
        { label: t(`${PRE}-FCC`), value: 'fcc' },
        { label: t(`${PRE}-CENTER`), value: 'center' },
      ],
    }
    // @ts-ignore
    return programTypeLookup[key]
  }

  return React.useMemo(
    () => whitelabeledProgramTypes(whitelabel.networkAbbr) || generalProgramTypes(),
    [i18n.language],
  )
}
